<template>
  <div>
    <clipboard-description />
    <clipboard-with-directive />
    <clipboard-without-directive />
  </div>
</template>

<script>
import ClipboardDescription from './ClipboardDescription.vue'
import ClipboardWithDirective from './ClipboardWithDirective.vue'
import ClipboardWithoutDirective from './ClipboardWithoutDirective.vue'

export default {
  components: {
    ClipboardDescription,
    ClipboardWithDirective,
    ClipboardWithoutDirective,
  },
}
</script>
